import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { QueryParamProvider } from 'use-query-params';
import { WindowHistoryAdapter } from 'use-query-params/adapters/window';
import client from './src/apollo/client';
import Provider from './src/context/context';
import Layout from './src/components/layout';

export const wrapRootElement = ({ element }) => (
	<ApolloProvider client={client}>
		<QueryParamProvider adapter={WindowHistoryAdapter}>
			<Provider element={element} />
		</QueryParamProvider>
	</ApolloProvider>
);

export const wrapPageElement = ({ element, props }) => {
	return <Layout {...props}>{element}</Layout>;
};